import type { models } from "jiffy-api";
import type { ArtworkPlacementForm, DesignLabFormType } from "@design-lab/shared/types";
import { isEditMode } from "@design-lab/shared/lib/misc";
import type { printOnDemand } from "common/utils/models";

// Helper function to create default artwork data
export function createDefaultArtworkData(
  product?: printOnDemand.getProduct.Response
): DesignLabFormType["artwork"] {
  let selectedFrontPlacement = "front";
  const isEditModeValue = isEditMode();

  if (!isEditModeValue) {
    const { sides } = product?.surfaceMeta || {};
    selectedFrontPlacement =
      sides?.front?.includes("front_left_chest") && !sides?.front?.includes("front")
        ? "frontLeftChest"
        : "front";
  }

  return {
    designProjectUuid: undefined,
    currentPlacement: "front",
    selectedFrontPlacement: selectedFrontPlacement as keyof ArtworkPlacementForm,
    front: { artworkId: "", size: { width: 0, height: 0 } },
    back: { artworkId: "", size: { width: 0, height: 0 } },
    frontLeftChest: { artworkId: "", size: { width: 0, height: 0 } },
    info: {
      front: {
        enhancementTier: "full_enhancements" as models.cart.madeAdd.EnhancementTier,
        removeBackground: true,
        enhancementRequestNote: "",
        editImageManual: false
      },
      back: {
        enhancementTier: "full_enhancements" as models.cart.madeAdd.EnhancementTier,
        removeBackground: true,
        enhancementRequestNote: "",
        editImageManual: false
      }
    }
  };
}
